import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "spinner" };
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Spinner',
    props: {
        loading: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(Icon, {
                    name: "spinner",
                    "icon-style": "duotone",
                    spin: true
                })
            ], 512)), [
                [_vShow, __props.loading]
            ]);
        };
    }
});
